import { useEffect } from 'react';
import { useProjectStore } from '../store/projectStore';
import { useUiStore } from '../store/uiStore';
import { ProjectEditor } from './ProjectEditor';

/**
 * Mounts the wizard at /projects/new.
 * Clears any in-progress project from the store and resets to step 1.
 */
export function NewProject() {
  const clearProject = useProjectStore(st => st.clearProject);
  const setCurrentStep = useUiStore(st => st.setCurrentStep);

  useEffect(() => {
    clearProject();
    setCurrentStep(1);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <ProjectEditor />;
}
